import request from 'utils/axios';
import { OnboardingMessagesResponse, UpdateOnboardingMessageRequest } from './types';
import { Method } from 'axios';
import { httpVerbs, PERSON_MANAGEMENT_BASE_URL } from 'configs';

const SEGMENT = `${PERSON_MANAGEMENT_BASE_URL}/api/v1/onboarding-messages`;

export const getOnboardingMessages = async (userId: string): Promise<OnboardingMessagesResponse> => {
  const response = await request({
    url: `${SEGMENT}/${userId}`,
    method: httpVerbs.GET as Method,
  });
  return response;
};

export const getRevisitOnboardingMessages = async (userId: string): Promise<OnboardingMessagesResponse> => {
  const response = await request({
    url: `${SEGMENT}/re-visit/${userId}`,
    method: httpVerbs.GET as Method,
  });
  return response;
};

export const updateOnboardingMessage = async (
  payload: UpdateOnboardingMessageRequest,
): Promise<OnboardingMessagesResponse> => {
  const { data } = await request({
    url: `${SEGMENT}/status`,
    method: httpVerbs.PUT as Method,
    data: payload,
  });
  return data;
};
